// @core/api/endpoints/subscription/get_subscription.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  SubscriptionResponse,
} from '../../../types/subscription';

const BASE_PATH = '/subscription';

/**
 * Get subscription details
 * Retrieves complete subscription information including current plan, billing status, usage limits, and renewal settings.
 */
export async function GetSubscription(
  subscription_id: string,
  options?: RequestOptions
): Promise<SubscriptionResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/subscriptions/:subscription_id`;
  requestPath = requestPath.replace(':subscription_id', encodeURIComponent(subscription_id));
  const requestOptions = options;
  return client.get<SubscriptionResponse>(requestPath, { ...requestOptions });
}
